import React from 'react';

/**
 * Lightweight React error boundary.
 * Wrap any section that could crash on bad data so the rest of the page stays usable.
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('UI ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="bg-rose-500/10 border border-rose-500/30 rounded-sm p-3 text-sm text-rose-300" data-testid="error-boundary-fallback">
          <p className="font-semibold mb-1">Erreur d'affichage / Display error</p>
          <p className="text-xs text-rose-200/80">
            Cette section n'a pas pu s'afficher. Veuillez rafraîchir la page (F5). / This section failed to render. Please refresh the page (F5).
          </p>
          {this.state.error?.message && (
            <p className="text-[10px] text-rose-200/60 mt-1 font-mono break-all">{String(this.state.error.message).slice(0, 200)}</p>
          )}
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
